import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = ({
  title = "À L'AISE",
  tagline = 'BY THE LAKE',
  rootClass = '',
  contentClass = '',
  useSlideshow = false,
  images = []
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (useSlideshow && images.length > 0) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % images.length
        );
      }, 5000); // Ganti gambar setiap 5 detik

      return () => clearInterval(interval);
    }
  }, [useSlideshow, images.length]);

  return (
    <section className={`hero-section ${rootClass}`.trim()}>
      {/* Slideshow Background */}
      {useSlideshow && images.length > 0 && (
        <div className="hero-slideshow">
          {images.map((image, index) => (
            <div
              key={index}
              className={`hero-slide ${index === currentImageIndex ? 'active' : ''}`}
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          ))}
        </div>
      )}
      
      <div className="hero-background-overlay"></div>
      <div className="hero-particle-effect"></div>
      <div className={`hero-content animate-up animate ${contentClass}`.trim()}>
        <h1 className="hero-title">{title}</h1>
        <p className="hero-tagline">{tagline}</p>
      </div>
      <div className="hero-scroll-indicator">
        <span>Scroll to Discover</span>
        <div className="scroll-line"></div>
      </div>
    </section>
  );
};

export default Hero;
